<template>
  <el-alert v-if="isShow" class="custom-alert" type="info" @close="handleToggleAlert">
    <template #title>
      <div class="alert-content d-flex align-items-center gap-2">
        <span class="text-warning">
          <i v-if="isLoading" class="fas fa-circle-notch fa-spin custom-icon"></i>
          <i v-else class="fa-solid fa-circle-check custom-icon"></i>
        </span>
        <span class="alert-message fs-5 fw-normal text-reset">{{ message }}</span>
      </div>
    </template>
    <el-button class="close-btn" type="text" size="small" icon="el-icon-close" @click="handleToggleAlert" />
  </el-alert>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-facing-decorator';

enum Message {
  PROCESS = 'Download process...',
  FINISH = 'Download Successed!',
}

@Component({
  emits: ['handleToggleAlert'],
})
@Component
export default class AlertLoading extends Vue {
  // @Prop({ default: '' }) message!: string;
  @Prop({ default: false }) isShow!: boolean;
  @Prop({ default: false }) isLoading!: boolean;

  message: string = Message.PROCESS;

  @Watch('isLoading', { immediate: false, deep: false })
  onIsLoadingChanged(newValue: any): void {
    this.message = newValue ? Message.PROCESS : Message.FINISH;
  }

  handleToggleAlert(): void {
    this.$emit('handleToggleAlert');
  }
}
</script>

<style lang="scss" scoped>
.custom-alert {
  position: fixed;
  right: 40px;
  bottom: 40px;
  max-width: 240px;
  border-radius: 6px;
  z-index: 1000;
  padding: 6px 10px !important;
  background-color: rgb(255 255 255 / 60%); /* White with 50% opacity */
  backdrop-filter: blur(30px); /* Blur effect */
  -webkit-backdrop-filter: blur(30px);
  box-shadow: 0 4px 20px rgb(0 0 0 / 7%);
}

.custom-alert .el-alert__icon {
  margin-right: 10px;
  font-size: 20px;
}

.custom-alert .close-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 14px;
  color: #999;
  cursor: pointer;
}

.custom-alert .close-btn:hover {
  color: #666;
}
.alert-message {
  color: #000 !important;
}
</style>
